// extracted by mini-css-extract-plugin
module.exports = {"wrap":"common_wrap_3Jpu0","fanhui":"common_fanhui_3V6k7","fullScreen":"common_fullScreen_-rNuK"};